import { render, staticRenderFns } from "./SettingsLocaleConfig.vue?vue&type=template&id=591adee7&scoped=true"
import script from "./SettingsLocaleConfig.vue?vue&type=script&lang=js"
export * from "./SettingsLocaleConfig.vue?vue&type=script&lang=js"
import style0 from "./SettingsLocaleConfig.vue?vue&type=style&index=0&id=591adee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591adee7",
  null
  
)

export default component.exports